import { IUnit } from 'shared/domain/entities';

export default function mapUnitListToLocationHierarchyDictionary(
  units: IUnit[],
) {
  return units.reduce<Record<string, Record<string, IUnit[]>>>(
    (units, unit) => {
      const state = unit.address.state;
      const city = unit.address.city;

      if (!units[state]) {
        units[state] = {
          [city]: [unit],
        };

        return units;
      }

      if (!units[state][city]) {
        units[state][city] = [unit];

        return units;
      }

      units[state][city].push(unit);

      return units;
    },
    {},
  );
}
